import { SESSION_LENGTH_MS } from '@misc/constants'
import { keychainManager } from '@plug-core/keyring'
import { logger } from '@plug-core/logger'
import { useConnectionProvider } from '@plug-core/state'
import { disconnectOisy } from '@utils/oisy'
import { disconnectFromPlugExtension } from '@utils/plugExtension'

export const setConnectionSessionInterval = () => {
  setInterval(() => {
    const { provider, connectedAt } = useConnectionProvider.getState()

    if (!connectedAt || (provider !== 'plug' && provider !== 'oisy')) {
      return
    }

    if (Date.now() - connectedAt >= SESSION_LENGTH_MS) {
      keychainManager.clearVault()
      useConnectionProvider.setState({ provider: null })

      if (provider === 'plug') {
        disconnectFromPlugExtension().catch(logger.debug)
      } else if (provider === 'oisy') {
        disconnectOisy().catch(logger.debug)
      }
    }
  }, 1000)
}
